import { render } from "./AiView.vue?vue&type=template&id=25abce0d&scoped=true&ts=true"
import script from "./AiView.vue?vue&type=script&lang=ts"
export * from "./AiView.vue?vue&type=script&lang=ts"

import "./AiView.vue?vue&type=style&index=0&id=25abce0d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25abce0d"]])

export default __exports__